import styled from 'styled-components'
import { Layout } from 'components/Layout'
import { LoginForm } from 'components/Login/LoginForm'
import { Row } from 'components/atoms/Row'
import { useUser } from '@supabase/auth-helpers-react'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { BackButton } from 'components/atoms/BackButton'

export default function SignInPage() {
  const user = useUser()
  const router = useRouter()

  useEffect(() => {
    if (user) {
      router.push('/')
    }
  }, [router, user])

  return (
    <Layout hideNavigation hideAccountSection centered>
      <SigninBackButton />
      <Wrapper>{!user && <LoginForm />}</Wrapper>
    </Layout>
  )
}

const Wrapper = styled(Row)`
  justify-content: center;
`
const SigninBackButton = styled(BackButton)`
  margin-top: 8px;
  min-height: 32px;
`
